export default __webpack_public_path__ + "static/media/fresco-logo.b7375a4c.svg";